var map = {
	"./icon-blog-career-advice.svg": 1379,
	"./icon-blog-career-guides.svg": 1380,
	"./icon-blog-edit.svg": 1341,
	"./icon-blog-excel-tutorials.svg": 1381,
	"./icon-blog-expert-interviews.svg": 1382,
	"./icon-blog-job-interview-tips.svg": 1383,
	"./icon-blog-machine-learning-tutorials.svg": 1384,
	"./icon-blog-meet-the-team.svg": 1385,
	"./icon-blog-news.svg": 1386,
	"./icon-blog-python-tutorials.svg": 1387,
	"./icon-blog-quote.svg": 1388,
	"./icon-blog-r-tutorials.svg": 1389,
	"./icon-blog-sql-tutorials.svg": 1390,
	"./icon-blog-statistics-tutorials.svg": 1391,
	"./icon-blog-tableau-tutorials.svg": 1392,
	"./icon-blog-time-series-analysis-tutorials.svg": 1393,
	"./icon-blog-trending.svg": 1394,
	"./icon-blog-tutorials.svg": 1395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1474;